import ClipboardJS from 'clipboard'
import { useEffect } from 'react'

const useClipboard = (selector: string, onSuccess: (e: any) => void, onError: (e: any) => void) => {
  useEffect(() => {
    const clipboard = new ClipboardJS(selector)
    clipboard.on('success', onSuccess)
    clipboard.on('error', onError)
    return () => {
      clipboard.destroy()
    }
  }, [selector, onSuccess, onError])
}
export default useClipboard
